import { create } from "zustand";

import { PricingTier, SpecificCalculation } from "@/features/finances/api/creditsPricing";

interface BuyCreditsData {
  payment_id: string;
  client_secret: string;
  session_id: string;
}

interface PricingData {
  currency: string;
  packages: PricingTier[];
  specific_calculation?: SpecificCalculation;
}

interface BuyCreditsStore {
  data: BuyCreditsData | null;
  pricingData: PricingData | null;
  selectedCredits: number;
  isLoading: boolean;
  isSummaryLoading: boolean;
  error: string | null;
  pricingError: string | null;

  // Actions
  setData: (data: BuyCreditsData) => void;
  setPricingData: (data: PricingData) => void;
  setSelectedCredits: (credits: number) => void;
  setLoading: (loading: boolean) => void;
  setSummaryLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setPricingError: (error: string | null) => void;
  clearData: () => void;
  reset: () => void;
}

export const useBuyCreditsStore = create<BuyCreditsStore>((set) => ({
  data: null,
  pricingData: null,
  selectedCredits: 50,
  isLoading: false,
  isSummaryLoading: false,
  error: null,
  pricingError: null,

  setData: (data) => set({ data, error: null }),
  setPricingData: (data) => set({ pricingData: data, pricingError: null }),
  setSelectedCredits: (credits) => set({ selectedCredits: credits }),
  setLoading: (loading) => set({ isLoading: loading }),
  setSummaryLoading: (loading) => set({ isSummaryLoading: loading }),
  setError: (error) => set({ error, isLoading: false }),
  setPricingError: (error) => set({ pricingError: error }),
  clearData: () => set({ data: null }),
  reset: () =>
    set({
      data: null,
      pricingData: null,
      selectedCredits: 50,
      isLoading: false,
      isSummaryLoading: false,
      error: null,
      pricingError: null,
    }),
}));
